import {
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    HostBinding,
    Input,
    OnDestroy,
    OnInit,
    Renderer2,
    RendererStyleFlags2,
    ViewChild
} from '@angular/core';
import { resizeObservable } from '@df/dom/fn/resize-observable';
import { TimeoutService } from '@df/ng/timeout.service';
import { Subscription } from 'rxjs';

/**
 * Magical component used to make inner scrollable while keeping
 * overlaying dropdowns visible
 *
 * its a thing to make overflow-x:visible + overflow-y:scroll what is not doable in pure css
 */
@Component({
    selector: 'scrollable',
    templateUrl: 'scrollable.html',
    styleUrls: ['scrollable.scss'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ScrollableComponent implements OnDestroy, OnInit {
    private resizeSubscription?: Subscription;
    private subscriptions = new Subscription();

    @Input()
    @HostBinding('class._dynamic')
    dynamic;

    constructor(
        private elementRef: ElementRef,
        private renderer2: Renderer2,
        private timeoutService: TimeoutService
    ) {}

    ngOnInit() {}

    @ViewChild('fake', { read: ElementRef })
    protected fake?: ElementRef<HTMLElement>;

    @ViewChild('real', { read: ElementRef })
    protected real?: ElementRef<HTMLElement>;

    @ViewChild('inner', { read: ElementRef })
    protected set inner(innerElementRef: ElementRef<HTMLElement>) {
        this.resizeSubscription?.unsubscribe();
        this.resizeSubscription = resizeObservable(innerElementRef.nativeElement, (event: ResizeObserverEntry) => {
            this.renderer2.setStyle(
                this.elementRef.nativeElement,
                '--scrollable-height',
                `${event.borderBoxSize[0].blockSize}px`,
                RendererStyleFlags2.DashCase
            );
        }).subscribe();
    }

    ngOnDestroy(): void {
        this.resizeSubscription?.unsubscribe();
        this.subscriptions.unsubscribe();
    }

    private source?: HTMLElement;
    private sourceTimeout?: number;

    protected onScroll(event: Event) {
        if (this.fake && this.real) {
            this.passScrollTop(this.real.nativeElement, this.fake.nativeElement);
        }
    }

    protected onFakeScroll(event: Event) {
        if (this.fake && this.real) {
            this.passScrollTop(this.fake.nativeElement, this.real.nativeElement);
        }
    }

    private passScrollTop(from: HTMLElement, to: HTMLElement) {
        if (this.source && this.source !== from) {
            return;
        }
        clearTimeout(this.sourceTimeout);
        this.source = from;

        const current = to.scrollTop;
        const dest = from.scrollTop;
        if (current !== dest) {
            to.scrollTop = dest;
        }
        this.sourceTimeout = this.timeoutService.setTimeout(() => {
            this.source = undefined;
        }, 100);
    }
}
